import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MV',
  name: 'María V.',
  location: 'Buenos Aires',
  text: 'En una semana mis hijos dejaron de pedirme el celular a cada rato. El sistema de misiones los enganchó desde el primer día. Vale cada peso.'
}, {
  initials: 'CR',
  name: 'Carolina R.',
  location: 'Córdoba · Mamá de 3',
  text: 'Nunca pensé que iba a poder cocinar en paz. Con el pack armado tengo 30 minutos reales todos los días. Los chicos lo piden solos.'
}, {
  initials: 'SL',
  name: 'Sofía L.',
  location: 'Rosario',
  text: 'El tablero de control familiar fue lo que más nos cambió la dinámica en casa. Mi hijo pide hacer las actividades para ganar sus estrellas.'
}];
export function Testimonials() {
  return <section className="py-12 px-4 bg-zinc-950" data-id="element-227">
      <div className="max-w-6xl mx-auto" data-id="element-228">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-229">
          {testimonials.map((t, i) => <div key={i} className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-8 relative" data-id="element-230">
              <div className="flex items-center gap-1 text-yellow-400 mb-4" data-id="element-231">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-232" />)}
              </div>
              <p className="text-zinc-300 text-lg italic mb-6" data-id="element-233">"{t.text}"</p>
              <div className="flex items-center gap-3" data-id="element-234">
                <div className="w-10 h-10 rounded-full bg-cyan-500/20 text-cyan-400 flex items-center justify-center font-bold" data-id="element-235">
                  {t.initials}
                </div>
                <div className="text-sm text-zinc-500" data-id="element-236">
                  — {t.name}, {t.location}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}